module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@3x-256e5b6c16b4b5d1892180462464b550.png";